import React, { useEffect, useRef, useState } from "react";
import OpenSeadragon from "openseadragon";

// full screen zoomable image popup - same look as the deep zoom viewer in edit case.
// tileSource comes from getViewerTileSource (deep zoom tiles for tiff, plain image otherwise)
const ShareImageViewer = ({ tileSource, title, onClose }) => {
    const viewerRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const [loadFailed, setLoadFailed] = useState(false);

    useEffect(() => {
        if (!viewerRef.current || !tileSource) {
            setIsLoading(false);
            setLoadFailed(!tileSource);
            return;
        }
        setIsLoading(true);
        setLoadFailed(false);

        const osdViewer = OpenSeadragon({
            element: viewerRef.current,
            prefixUrl: "https://openseadragon.github.io/openseadragon/images/",
            tileSources: tileSource,
            showNavigator: true,
            crossOriginPolicy: "Anonymous",
            navigatorPosition: "BOTTOM_RIGHT",
            maxZoomPixelRatio: 10,
            minZoomImageRatio: 0.5,
            visibilityRatio: 1,
            zoomPerScroll: 2,
            homeFillsViewer: true,
            gestureSettingsMouse: {
                clickToZoom: true,
                dblClickToZoom: true,
                flickEnabled: true,
                pinchToZoom: true,
                scrollToZoom: true,
            },
            showZoomControl: true,
            showHomeControl: true,
            showFullPageControl: true,
            showRotationControl: true,
            wrapHorizontal: false,
        });
        osdViewer.addHandler("open", () => setIsLoading(false));
        osdViewer.addHandler("open-failed", () => {
            setIsLoading(false);
            setLoadFailed(true);
        });

        return () => osdViewer.destroy();
    }, [tileSource]);

    useEffect(() => {
        const handleKeyDown = (e) => { if (e.key === "Escape") onClose(); };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [onClose]);

    return (
        <div className="deep_zoom">
            <div
                style={{
                    position: "fixed",
                    top: '0',
                    left: '0',
                    right: '0',
                    bottom: '0',
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 999,
                    borderRadius: "18px"
                }}
            >
                <div style={{
                    width: "98vw",
                    height: "98vh",
                    position: "relative",
                    backgroundColor: "black",
                    overflow: "hidden"
                }}>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0 20px",
                        height: "52px",
                        background: "linear-gradient(135deg, #091918 0%, #215250 100%)",
                        borderBottom: "1px solid rgba(255,255,255,0.08)",
                        boxShadow: "0 2px 12px rgba(0,0,0,0.4)",
                    }}>
                        <span style={{ color: "#ffffff", fontSize: "13px", fontWeight: "600", letterSpacing: "0.5px" }}>
                            {title}
                        </span>
                        <button
                            className="dz_close"
                            onClick={onClose}
                            title="Close"
                            style={{
                                border: "1px solid rgba(255,255,255,0.15)",
                                background: "rgba(255,255,255,0.07)",
                                color: "#ffffff",
                                borderRadius: "50%",
                                width: "34px",
                                height: "34px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                fontWeight: "800",
                            }}
                        >
                            <span className="material-symbols-outlined" style={{ fontSize: "18px", lineHeight: 1 }}>close</span>
                        </button>
                    </div>

                    <div style={{
                        height: "calc(95vh - 80px)",
                        width: "100%",
                        position: "relative"
                    }}>
                        <div ref={viewerRef} style={{ height: "100%", width: "100%" }} />

                        {loadFailed && (
                            <div style={{
                                position: "absolute", inset: 0, zIndex: 20,
                                display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "8px",
                                color: "rgba(255,255,255,0.7)", fontSize: "15px", fontWeight: 600,
                            }}>
                                <span className="material-symbols-outlined" style={{ fontSize: "48px" }}>broken_image</span>
                                This image could not be loaded.
                            </div>
                        )}

                        {isLoading && (
                            <div style={{
                                position: "absolute", inset: 0,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                background: "rgba(0,0,0,0.55)", zIndex: 20, pointerEvents: "none",
                            }}>
                                <div style={{
                                    width: "52px", height: "52px", borderRadius: "50%",
                                    border: "4px solid rgba(255,255,255,0.15)",
                                    borderTopColor: "#EA7F4A",
                                    animation: "dz-spin 0.75s linear infinite",
                                }} />
                                <style>{`@keyframes dz-spin { to { transform: rotate(360deg); } }`}</style>
                            </div>
                        )}

                        <div
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                color: "grey",
                                fontSize: "2vw",
                                fontWeight: "600",
                                textTransform: "uppercase",
                                letterSpacing: "2px",
                                textShadow: "1px 1px 4px rgba(0,0,0,0.6)",
                                pointerEvents: "none",
                                zIndex: 10,
                                userSelect: "none"
                            }}
                        >
                            Copyright © 2026 DADI
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShareImageViewer;
